import React from 'react';
import { Shield } from 'lucide-react';
import { trackAddToCart } from '../../lib/pixel';
interface CTAButtonProps {
  text?: string;
  className?: string;
  onClick?: () => void;
  pulse?: boolean;
  href?: string;
}
export function CTAButton({
  text = 'SÍ, QUIERO ROMPER MIS CADENAS HOY',
  className = '',
  onClick,
  pulse = false,
  href
}: CTAButtonProps) {
  const isExternal = !!href;
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    if (onClick) {
      e.preventDefault();
      onClick();
      return;
    }
    if (!isExternal) {
      e.preventDefault();
      const priceCard = document.getElementById('price-card');
      if (priceCard) {
        priceCard.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        });
      }
    } else {
      trackAddToCart();
    }
  };
  const button = <a href={href || '#price-card'} target={isExternal ? '_blank' : undefined} rel={isExternal ? 'noopener noreferrer' : undefined} onClick={handleClick} className={`
        relative inline-flex items-center justify-center gap-2 w-full md:w-auto text-center
        bg-gold hover:bg-gold-dark active:scale-[0.97] text-charcoal font-bold 
        py-4 px-8 md:px-10 rounded-full shadow-lg
        transition-all duration-200
        text-xs md:text-base tracking-wide uppercase
        border-2 border-gold-dark/30
        hover:scale-[1.03]
        ${className}
      `} data-id="element-188">
      <Shield size={18} className="shrink-0 hidden md:block" data-id="element-189" />
      <span className="leading-tight text-center" data-id="element-190">{text}</span>
    </a>;
  if (!pulse) return button;
  return <div className="relative inline-flex items-center justify-center w-full md:w-auto" data-id="element-191">
      <div className="animate-cta-pulse relative z-10 w-full md:w-auto" data-id="element-192">
        {button}
      </div>
    </div>;
}